<div class="jumbotron">
  <div class="form-row" style="margin-bottom: 2rem;">
    <div class="col-sm-8">
      <h3>Fire Cadet Academy Application Form</h3>
    </div>
    <div class="col-sm-4">
      <p style="margin:0;">
        <small style="margin-top: 12px;float: right;">
          All fields are required unless indicated as optional
        </small>
      </p>
    </div>
  </div>
  <form [formGroup]="cadetForm" (ngSubmit)="previewCadetForm(cadetForm)" novalidate>
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">PERSONAL INFORMATION</p>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
        <label for="uscitizenornot">Are you a US Citizen:</label>
      </div>
      <div class="form-group col-xl-9 col-lg-9 col-md-9 col-sm-9">
        <div class="form-check form-check-inline radiostyling">
          <input #UsCitzYes (click)="UsCitizenOptionYes()" class="form-check-input" type="radio" name="UsCitizenOptions" id="UsCitizenYes"
            value="Yes" [formControl]="cadetForm.controls['usCitizenChooseOne']">
          <label class="form-check-label" for="labelUsCitizenYes">Yes</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input #UsCitzNo (click)="UsCitizenOptionNo()" class="form-check-input" type="radio" name="UsCitizenOptions" id="UsCitizenNo"
            value="No" [formControl]="cadetForm.controls['usCitizenChooseOne']">
          <label class="form-check-label" for="labelUsCitizenNo">No</label>
        </div>
        <div *ngIf="cadetForm.get('usCitizenChooseOne').invalid" class="optionselectorNot" style="width: 125px;">
          Select one option
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3" [ngClass]="{'has-error':!cadetForm.controls['firstNamePers'].valid && cadetForm.controls['firstNamePers'].touched}">
        <label for="cadetfirstname">First Name:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="75" class="form-control" placeholder="Enter first name" id="firstnamepers"
          [formControl]="cadetForm.controls['firstNamePers']">
        <div *ngIf="cadetForm.controls['firstNamePers'].hasError('required') && cadetForm.controls['firstNamePers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['firstNamePers'].hasError('minlength') && cadetForm.controls['firstNamePers'].touched" class="alert alert-danger">Must be at least 2 characters long</div>
        <div *ngIf="cadetForm.controls['firstNamePers'].hasError('pattern') && cadetForm.controls['firstNamePers'].touched" class="alert alert-danger">Not a valid name, please enter only alphabets</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3" [ngClass]="{'has-error':!cadetForm.controls['middleNamePers'].valid && cadetForm.controls['middleNamePers'].touched}">
        <label for="cadetmiddlename">Middle I<small style="margin-left: 5px;"><i>(Optional)</i></small>:
          <!-- <small>
            <i>(Optional)</i>:</small> -->
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="75" class="form-control" id="middlenameselect" placeholder="Enter middle initial"
          [formControl]="cadetForm.controls['middleNamePers']">
        <div *ngIf="cadetForm.controls['middleNamePers'].hasError('maxlength') && cadetForm.controls['middleNamePers'].touched" class="alert alert-danger">You can not enter more than one alphabet</div>
        <div *ngIf="cadetForm.controls['middleNamePers'].hasError('pattern') && cadetForm.controls['middleNamePers'].touched" class="alert alert-danger">Not a valid name, please enter only alphabets</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3" [ngClass]="{'has-error':!cadetForm.controls['lastNamePers'].valid && cadetForm.controls['lastNamePers'].touched}">
        <label for="cadetlastname">Last Name:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="75" class="form-control" placeholder="Enter last name" id="lastnamepers"
          [formControl]="cadetForm.controls['lastNamePers']">
        <div *ngIf="cadetForm.controls['lastNamePers'].hasError('required') && cadetForm.controls['lastNamePers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['lastNamePers'].hasError('minlength') && cadetForm.controls['lastNamePers'].touched" class="alert alert-danger">Must be at least 2 characters long</div>
        <div *ngIf="cadetForm.controls['lastNamePers'].hasError('pattern') && cadetForm.controls['lastNamePers'].touched" class="alert alert-danger">Not a valid name, please enter only alphabets</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
        <label for="cadetsuffix">Suffix<small style="margin-left: 5px;"><i>(Optional)</i></small>:
        </label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="suffixnameselect" [(ngModel)]="defaultSuffixValue"
          [formControl]="cadetForm.controls['suffixNamePers']" style="width: 125px;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Jr.">Jr.</option>
          <option value="Sr.">Sr.</option>
          <option value="2nd">2nd</option>
          <option value="3rd">3rd</option>
          <option value="II">II</option>
          <option value="III">III</option>
          <option value="IV">IV</option>
          <option value="V">V</option>
          <option value="VI">VI</option>
        </select>
      </div>
    </div>
    <div class="form-row" style="margin: 0rem;padding: 0rem;">
      <div class="form-group col-xl-2 col-lg-2 col-md-3 col-sm-3 col-xs-3" style="margin:0rem;padding: 0rem;">
        <label for="dateofbirth">Date of Birth:</label>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-3" [ngClass]="{'has-error':!cadetForm.controls['dobMonthPers'].valid && cadetForm.controls['dobMonthPers'].touched}">
        <label for="dateofbirth" style="line-height: 0.5em;">
          <small>Month</small>
        </label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" [(ngModel)]="defaultMonthValue" class="custom-select" id="dobmonth" [formControl]="cadetForm.controls['dobMonthPers']">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="January">January</option>
          <option value="February">February</option>
          <option value="March">March</option>
          <option value="April">April</option>
          <option value="May">May</option>
          <option value="June">June</option>
          <option value="July">July</option>
          <option value="August">August</option>
          <option value="September">September</option>
          <option value="October">October</option>
          <option value="November">November</option>
          <option value="December">December</option>
        </select>
        <div *ngIf="cadetForm.controls['dobMonthPers'].hasError('required') && cadetForm.controls['dobMonthPers'].touched" class="alert alert-danger">Select a month</div>
      </div>
      <div class="form-group col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-3" [ngClass]="{'has-error':!cadetForm.controls['dobDatePers'].valid && cadetForm.controls['dobDatePers'].touched}">
        <label for="dateofbirth" style="line-height: 0.5em;">
          <small>Date</small>
        </label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" [(ngModel)]="defaultDateValue" class="custom-select" id="dobday" [formControl]="cadetForm.controls['dobDatePers']">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="01">01</option>
          <option value="02">02</option>
          <option value="03">03</option>
          <option value="04">04</option>
          <option value="05">05</option>
          <option value="06">06</option>
          <option value="07">07</option>
          <option value="08">08</option>
          <option value="09">09</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="13">13</option>
          <option value="14">14</option>
          <option value="15">15</option>
          <option value="16">16</option>
          <option value="17">17</option>
          <option value="18">18</option>
          <option value="19">19</option>
          <option value="20">20</option>
          <option value="21">21</option>
          <option value="22">22</option>
          <option value="23">23</option>
          <option value="24">24</option>
          <option value="25">25</option>
          <option value="26">26</option>
          <option value="27">27</option>
          <option value="28">28</option>
          <option value="29">29</option>
          <option value="30">30</option>
          <option value="31">31</option>
        </select>
        <div *ngIf="cadetForm.controls['dobDatePers'].hasError('required') && cadetForm.controls['dobDatePers'].touched" class="alert alert-danger">Select a date</div>
      </div>
      <div class="form-group col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-3" [ngClass]=" {'has-error':!cadetForm.controls['dobYearPers'].valid && cadetForm.controls['dobYearPers'].touched}">
        <label for="dateofbirth" style="line-height: 0.5em;">
          <small>Year</small>
        </label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" [(ngModel)]="defaultYearValue" class="custom-select" id="dobnumericalyear"
          [formControl]="cadetForm.controls['dobYearPers']">
          <option [ngValue]="undefined" selected>Select</option>
          <option *ngFor='let DOBYear of dobFieldValues' [value]="DOBYear.year">
            {{DOBYear.year}}
          </option>
        </select>
        <div *ngIf="cadetForm.controls['dobYearPers'].hasError('required') && cadetForm.controls['dobYearPers'].touched" class="alert alert-danger">Select a year</div>
      </div>
      <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-9 col-xs-9 doblabel">

        <small for="dateofbirth">(Must be at least <strong>18</strong> years of age and not above <strong>26</strong> years of age on the date of submitting the application)
        </small>
        <!-- </label> -->
      </div>
    </div>
    <div class="form-row" style="margin-left:0px;" *ngIf="invalidDob">
      <div class="alert alert-danger col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6" *ngIf="invalidDob">{{invalidAgeMsg}}</div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-4 col-xs-4" [ngClass]="{'has-error':!cadetForm.controls['ssnPers'].valid && cadetForm.controls['ssnPers'].touched}">
        <label for="ssnlastfourdigits">Social Security #:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="5" class="form-control" placeholder="Enter only digits" [formControl]="cadetForm.controls['ssnPers']">
        <div *ngIf="cadetForm.controls['ssnPers'].hasError('required') && cadetForm.controls['ssnPers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['ssnPers'].hasError('minlength') && cadetForm.controls['ssnPers'].touched" class="alert alert-danger">Enter 5 digits</div>
        <div *ngIf="cadetForm.controls['ssnPers'].hasError('maxlength') && cadetForm.controls['ssnPers'].touched" class="alert alert-danger">You can not enter more than 5 digits</div>
        <div *ngIf="cadetForm.controls['ssnPers'].hasError('pattern') && cadetForm.controls['ssnPers'].touched" class="alert alert-danger">Not a valid SSN, please enter only digits</div>
      </div>
      <div class="form-group col-md-9 col-sm-9 ssnlabel">
        <small style="font-style: italic;">(Last
          <strong>5</strong> digits only)</small>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6" [ngClass]="{'has-error':!cadetForm.controls['strtAddrPers'].valid && cadetForm.controls['strtAddrPers'].touched}">
        <label for="streetaddr">Street Address:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" class="form-control" placeholder="Enter full address" [formControl]="cadetForm.controls['strtAddrPers']">
        <div *ngIf="cadetForm.controls['strtAddrPers'].hasError('required') && cadetForm.controls['strtAddrPers'].touched" class="alert alert-danger">Required</div>
      </div>
      <div class="form-group col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-4">
        <label for="aptnumber">Apt/Floor<small style="margin-left: 5px;"><i>(Optional)</i></small>:
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="75" class="form-control" placeholder="" [formControl]="cadetForm.controls['aptNumPers']">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-4 col-xs-4" [ngClass]="{'has-error':!cadetForm.controls['cityNamePers'].valid && cadetForm.controls['cityNamePers'].touched}">
        <label for="cityname">City:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="75" class="form-control" placeholder="Enter city" [formControl]="cadetForm.controls['cityNamePers']">
        <div *ngIf="cadetForm.controls['cityNamePers'].hasError('required') && cadetForm.controls['cityNamePers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['cityNamePers'].hasError('pattern') && cadetForm.controls['cityNamePers'].touched" class="alert alert-danger">Not a valid city name</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-4 col-xs-4" [ngClass]="{'has-error':!cadetForm.controls['stateNamePers'].valid && cadetForm.controls['stateNamePers'].touched}">
        <label for="statename">State:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" class="form-control" [(ngModel)]="defaultStateValue" placeholder="Enter 2 letter state name"
          [formControl]="cadetForm.controls['stateNamePers']" [(ngModel)]="stateDisplay" [ngbTypeahead]="statesearch">
        <div *ngIf="cadetForm.controls['stateNamePers'].hasError('required') && cadetForm.controls['stateNamePers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['stateNamePers'].hasError('minlength') && cadetForm.controls['stateNamePers'].touched" class="alert alert-danger">Enter two characters for the state abbv.</div>
        <div *ngIf="cadetForm.controls['stateNamePers'].hasError('maxlength') && cadetForm.controls['stateNamePers'].touched" class="alert alert-danger">You can not enter more than 2 characters</div>
        <div *ngIf="cadetForm.controls['stateNamePers'].hasError('pattern') && cadetForm.controls['stateNamePers'].touched" class="alert alert-danger">Not a valid state abbv., please enter only alphabets</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-4 col-xs-4" [ngClass]="{'has-error':!cadetForm.controls['zipCodePers'].valid && cadetForm.controls['zipCodePers'].touched}">
        <label for="zipcodepers">Zip Code:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="5" class="form-control" placeholder="Enter 5 digit zip code" [formControl]="cadetForm.controls['zipCodePers']">
        <div *ngIf="cadetForm.controls['zipCodePers'].hasError('required') && cadetForm.controls['zipCodePers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['zipCodePers'].hasError('minlength') && cadetForm.controls['zipCodePers'].touched" class="alert alert-danger">Enter 5 digits</div>
        <div *ngIf="cadetForm.controls['zipCodePers'].hasError('maxlength') && cadetForm.controls['zipCodePers'].touched" class="alert alert-danger">You can not enter more than 5 digits</div>
        <div *ngIf="cadetForm.controls['zipCodePers'].hasError('pattern') && cadetForm.controls['zipCodePers'].touched" class="alert alert-danger">Not a valid zip code, please enter only digits</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-4 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['countryNamePers'].valid && cadetForm.controls['countryNamePers'].touched}">
        <label for="countrypers">Country:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" [(ngModel)]="defaultCountryValue" class="custom-select" id="countrypersselection"
          [formControl]="cadetForm.controls['countryNamePers']">
          <option [ngValue]="undefined" selected>Select</option>
          <option *ngFor='let listofCountry of listofCountries' [value]="listofCountry.name">
            {{listofCountry.name}}
          </option>
        </select>
        <div *ngIf="cadetForm.controls['countryNamePers'].hasError('required') && cadetForm.controls['countryNamePers'].touched"
          class="alert alert-danger">You must select a country</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-5 col-sm-6 col-xs-6" [ngClass]="{'has-error':!cadetForm.controls['cellNumPers'].valid && cadetForm.controls['cellNumPers'].touched}">
        <label for="cellnumpers">Cell/Primary Number:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="10" class="form-control" placeholder="10 digits with no symbols" [formControl]="cadetForm.controls['cellNumPers']">
        <div *ngIf="cadetForm.controls['cellNumPers'].hasError('required') && cadetForm.controls['cellNumPers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['cellNumPers'].hasError('minlength') && cadetForm.controls['cellNumPers'].touched" class="alert alert-danger">Enter 10 digits</div>
        <div *ngIf="cadetForm.controls['cellNumPers'].hasError('maxlength') && cadetForm.controls['cellNumPers'].touched" class="alert alert-danger">You can not enter more than 10 digits</div>
        <div *ngIf="cadetForm.controls['cellNumPers'].hasError('pattern') && cadetForm.controls['cellNumPers'].touched" class="alert alert-danger">Not a valid number, please enter only digits</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-5 col-sm-6 col-xs-6" [ngClass]="{'has-error':!cadetForm.controls['homeNumPers'].valid && cadetForm.controls['homeNumPers'].touched}">
        <label for="homenumpers">Alternative Number<small style="margin-left: 5px;"><i>(Optional)</i></small>:
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="10" class="form-control" placeholder="10 digits with no symbols" [formControl]="cadetForm.controls['homeNumPers']">
        <div *ngIf="cadetForm.controls['homeNumPers'].hasError('minlength') && cadetForm.controls['homeNumPers'].touched" class="alert alert-danger">Enter 10 digits</div>
        <div *ngIf="cadetForm.controls['homeNumPers'].hasError('maxlength') && cadetForm.controls['homeNumPers'].touched" class="alert alert-danger">You can not enter more than 10 digits</div>
        <div *ngIf="cadetForm.controls['homeNumPers'].hasError('pattern') && cadetForm.controls['homeNumPers'].touched" class="alert alert-danger">Not a valid number, please enter only digits</div>
      </div>
      <!-- <div class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" [ngClass]="{'has-error':!cadetForm.controls['emailAddrPers'].valid && cadetForm.controls['emailAddrPers'].touched}">
        <label for="emailpers">Email Address:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" class="form-control" placeholder="abc@xyz.com" [formControl]="cadetForm.controls['emailAddrPers']"
          placement="top" ngbTooltip="Your Email address should be valid and active - which would be used for all future communication purposes.">
        <div *ngIf="cadetForm.controls['emailAddrPers'].hasError('required') && cadetForm.controls['emailAddrPers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['emailAddrPers'].hasError('pattern') && cadetForm.controls['emailAddrPers'].touched" class="alert alert-danger">Not a valid email address</div>
      </div> -->
    </div>
    <div class="form-row">
      <div class="form-group col-xl-4 col-lg-4 col-md-5 col-sm-6 col-xs-6" [ngClass]="{'has-error':!cadetForm.controls['emailAddrPers'].valid && cadetForm.controls['emailAddrPers'].touched}">
        <label for="emailpers">Email Address:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="75" class="form-control" placeholder="abc@xyz.com" [formControl]="cadetForm.controls['emailAddrPers']"
          placement="top" ngbTooltip="Your Email address should be valid and active - which would be used for all future communication purposes.">
        <div *ngIf="cadetForm.controls['emailAddrPers'].hasError('required') && cadetForm.controls['emailAddrPers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['emailAddrPers'].hasError('pattern') && cadetForm.controls['emailAddrPers'].touched" class="alert alert-danger">Not a valid email address</div>
      </div>
      <div class="form-group col-xl-4 col-lg-4 col-md-5 col-sm-5 col-xs-6" [ngClass]="{'has-error':!cadetForm.controls['emailAddrPers'].valid && cadetForm.controls['emailAddrPers'].touched}">
        <label for="emailpers">Confirm Email Address:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="75" class="form-control"  placeholder="abc@xyz.com" [formControl]="cadetForm.controls['confirmEmailAddrPers']"
          placement="top" ngbTooltip="Your Email address should be valid and active - which would be used for all future communication purposes.">
        <div *ngIf="cadetForm.controls['confirmEmailAddrPers'].hasError('required') && cadetForm.controls['confirmEmailAddrPers'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['confirmEmailAddrPers'].hasError('pattern') && cadetForm.controls['confirmEmailAddrPers'].touched" class="alert alert-danger">Not a valid email address</div>
        
        <div *ngIf="cadetForm.controls['confirmEmailAddrPers'].value != cadetForm.controls['emailAddrPers'].value && cadetForm.controls['confirmEmailAddrPers'].touched "  class="alert alert-danger">Email address does not match.</div>
     
     
      </div>
    </div>
    <!-- ################ Education Details ########################## -->
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">EDUCATIONAL DETAILS</p>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
        <label for="chooseoneselect">
          Select one:
        </label>
      </div>
      <div class="form-group col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9">
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="gradRadioOptions" id="gradNycHighSchool"
            value="New York City High School" [formControl]="cadetForm.controls['eduChooseOne']">
          <label class="form-check-label" for="NycHighSchool">I graduated from a New York City High School</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="gradRadioOptions" id="gradNycHseDiploma"
            value="High School Equivalency Diploma (HSE) from State of New York" [formControl]="cadetForm.controls['eduChooseOne']">
          <label class="form-check-label" for="NycHseDiploma" style="line-height: 1.2rem;">I have a High School Equivalency Diploma (HSE) from New York City</label>
        </div>
        <div *ngIf="cadetForm.get('eduChooseOne').invalid" class="optionselectorNot" style="width: 125px;">
          Select one option
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5" [ngClass]="{'has-error':!cadetForm.controls['schoolNameEdu'].valid && cadetForm.controls['schoolNameEdu'].touched}">
        <label for="highschoolinfo">Name of the School:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="120" class="form-control" placeholder="Enter school name" [formControl]="cadetForm.controls['schoolNameEdu']">
        <div *ngIf="cadetForm.controls['schoolNameEdu'].hasError('required') && cadetForm.controls['schoolNameEdu'].touched" class="alert alert-danger">Required</div>
      </div>
      <div class="form-group col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5" [ngClass]="{'has-error':!cadetForm.controls['schoolAddrEdu'].valid && cadetForm.controls['schoolAddrEdu'].touched}">
        <label for="addressinfo">Address<small style="margin-left: 5px;"><i>(Optional)</i></small>:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="120" class="form-control" placeholder="Enter full address" [formControl]="cadetForm.controls['schoolAddrEdu']">
        <!-- <div *ngIf="cadetForm.controls['schoolAddrEdu'].hasError('required') && cadetForm.controls['schoolAddrEdu'].touched" class="alert alert-danger">Required</div> -->
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3" [ngClass]="{'has-error':!cadetForm.controls['cityNameEdu'].valid && cadetForm.controls['cityNameEdu'].touched}">
        <label for="cityeduinfo">City:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="120" class="form-control" placeholder="Enter city" [formControl]="cadetForm.controls['cityNameEdu']">
        <div *ngIf="cadetForm.controls['cityNameEdu'].hasError('required') && cadetForm.controls['cityNameEdu'].touched" class="alert alert-danger">Required</div>
        <div *ngIf="cadetForm.controls['cityNameEdu'].hasError('pattern') && cadetForm.controls['cityNameEdu'].touched" class="alert alert-danger">Not a valid name, please enter only alphabets</div>
      </div>
      <div class="form-group col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-4">
        <label for="stateeduinfo">State:</label>
        <input type="text" tabindex="-1" class="form-control disablefieldInput" [formControl]="cadetForm.controls['stateNameEdu']">
      </div>
      <div class="form-group col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-4" [ngClass]="{'has-error':!cadetForm.controls['zipCodeEdu'].valid && cadetForm.controls['zipCodeEdu'].touched}">
        <label for="zipcodeeduinfo">Zip Code<small style="margin-left: 5px;"><i>(Optional)</i></small>:</label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="5" class="form-control" placeholder="Enter only digits" [formControl]="cadetForm.controls['zipCodeEdu']">
        <!-- <div *ngIf="cadetForm.controls['zipCodeEdu'].hasError('required') && cadetForm.controls['zipCodeEdu'].touched" class="alert alert-danger">Required</div> -->
        <div *ngIf="cadetForm.controls['zipCodeEdu'].hasError('minlength') && cadetForm.controls['zipCodeEdu'].touched" class="alert alert-danger">Enter 5 digits</div>
        <div *ngIf="cadetForm.controls['zipCodeEdu'].hasError('maxlength') && cadetForm.controls['zipCodeEdu'].touched" class="alert alert-danger">You can not enter more than 5 digits</div>
        <div *ngIf="cadetForm.controls['zipCodeEdu'].hasError('pattern') && cadetForm.controls['zipCodeEdu'].touched" class="alert alert-danger">Not a valid zip code, please enter only digits</div>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
        <label for="countryeduinfo">Country:</label>
        <input type="text" tabindex="-1" class="form-control disablefieldInput" [formControl]="cadetForm.controls['countryNameEdu']">
      </div>
    </div>
    <!-- ############### Employment Details ########################### -->
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">EMPLOYMENT DETAILS</p>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['yrsPaidEmpSelection'].valid && cadetForm.controls['yrsPaidEmpSelection'].touched}">
        <label for="employedyrs">Paid Employment Experience:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="employmentyearsselection" [(ngModel)]="defaultYrsPaidEmpSelection"
          [formControl]="cadetForm.controls['yrsPaidEmpSelection']" (change)="selectYrsEmployment($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['yrsPaidEmpSelection'].hasError('required') && cadetForm.controls['yrsPaidEmpSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
      <div *ngIf="defaultYrsPaidEmpSelection === 'Yes'" class="form-group col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-7 offset-xl-1 offset-lg-1 offset-md-1 edulabel">
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="EmpYrsRadioOptions" id="EmpYrsLessThan1"
            value="Less than 1 year" [formControl]="cadetForm.controls['YrsEmpSelectOne']">
          <label class="form-check-label" for="employmentyears1">Less than 1 year</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="EmpYrsRadioOptions" id="EmpYrsBtw12"
            value="1 to 2 Years" [formControl]="cadetForm.controls['YrsEmpSelectOne']">
          <label class="form-check-label" for="employmentyears2">1 - 2 years</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="EmpYrsRadioOptions" id="EmpYrsBtw23"
            value="2 to 3 Years" [formControl]="cadetForm.controls['YrsEmpSelectOne']">
          <label class="form-check-label" for="employmentyears3">2 - 3 years</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="EmpYrsRadioOptions" id="EmpYrs3Plus"
            value="More than 3 years" [formControl]="cadetForm.controls['YrsEmpSelectOne']">
          <label class="form-check-label" for="employmentyears4">3 years+</label>
        </div>
        <div *ngIf="cadetForm.get('YrsEmpSelectOne').invalid" class="optionselectorNot" style="width: 125px;">
          Select one option
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['intrnShipSelection'].valid && cadetForm.controls['intrnShipSelection'].touched}">
        <label for="internyrs" class="labelalign">Internship:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="internshipyearsselection" [(ngModel)]="defaultIntrnYrsSelection"
          [formControl]="cadetForm.controls['intrnShipSelection']" (change)="selectIntrnshp($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['intrnShipSelection'].hasError('required') && cadetForm.controls['intrnShipSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
      <div *ngIf="defaultIntrnYrsSelection === 'Yes'" class="form-group col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-7 offset-xl-1 offset-lg-1 offset-md-1 yremplabel">
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="IntrnYrsRadioOptions" id="IntrnYrs6Mnths"
            value="Upto 6 Months" [formControl]="cadetForm.controls['intrnShipSelectOne']">
          <label class="form-check-label" for="internshipyears1">Up to 6 months</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="IntrnYrsRadioOptions" id="IntrnYrsBtw6M1"
            value="6 months to 1 year" [formControl]="cadetForm.controls['intrnShipSelectOne']">
          <label class="form-check-label" for="internshipyears2">6 months - 1 year</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="IntrnYrsRadioOptions" id="IntrnYrs1Plus"
            value="More than 1 year" [formControl]="cadetForm.controls['intrnShipSelectOne']">
          <label class="form-check-label" for="internshipyears3">1 year+</label>
        </div>
        <div *ngIf="cadetForm.get('intrnShipSelectOne').invalid" class="optionselectorNot" style="width: 125px;">
          Select one option
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['currentEmplySelection'].valid && cadetForm.controls['currentEmplySelection'].touched}">
        <label for="currentemployedyrs" class="labelalign">Currently Employed:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="currentemployedyearsselection" [(ngModel)]="defaultCurrentEmplySelection"
          [formControl]="cadetForm.controls['currentEmplySelection']" (change)="selectCurrentEmplyment($event.target.value)"
          style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['currentEmplySelection'].hasError('required') && cadetForm.controls['currentEmplySelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
      <div *ngIf="defaultCurrentEmplySelection === 'Yes'" class="form-group col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-7 offset-xl-1 offset-lg-1 offset-md-1 edulabel">
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="CurEmpRadioOptions" id="CurEmpFullTime"
            value="Full-time Employment" [formControl]="cadetForm.controls['currentEmplySelectOne']">
          <label class="form-check-label" for="currentlyemployed1">Full-time</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" class="form-check-input" type="radio" name="CurEmpRadioOptions" id="CurEmpPartTime"
            value="Part-time Employment" [formControl]="cadetForm.controls['currentEmplySelectOne']">
          <label class="form-check-label" for="currentlyemployed2">Part-time</label>
        </div>
        <div *ngIf="cadetForm.get('currentEmplySelectOne').invalid" class="optionselectorNot" style="width: 125px;">
          Select one option
        </div>
      </div>
      <div *ngIf="defaultCurrentEmplySelection === 'Yes'" [ngClass]="{'has-error':!cadetForm.controls['workTypeEdu'].valid && cadetForm.controls['workTypeEdu'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-5 col-xs-4 offset-xl-4 offset-lg-4 offset-md-4 offset-sm-3">
        <label for="typeofwork">
          <small>
            <i>Please specify the work type:</i>
          </small>
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="120" class="form-control" placeholder="Enter work type" [formControl]="cadetForm.controls['workTypeEdu']">
        <div *ngIf="cadetForm.controls['workTypeEdu'].hasError('required') && cadetForm.controls['workTypeEdu'].touched" class="alert alert-danger">Required</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['jobTermSelection'].valid && cadetForm.controls['jobTermSelection'].touched}">
        <label for="terminatedjob">Have you ever been
          <br>terminated from a job:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="terminatedjobselection" [(ngModel)]="defaultJobTermSelection"
          [formControl]="cadetForm.controls['jobTermSelection']" (change)="selectJobTerminated($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['jobTermSelection'].hasError('required') && cadetForm.controls['jobTermSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
      <div *ngIf="defaultJobTermSelection === 'Yes'" [ngClass]=" {'has-error':!cadetForm.controls['jobTermReason'].valid && cadetForm.controls['jobTermReason'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 offset-xl-1 offset-lg-1 offset-md-1 termlabel">
        <label for="reasonjobterm">
          <small>
            <i>Please specify the reason:</i>
          </small>
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="500" class="form-control" placeholder="Enter brief reason" [formControl]="cadetForm.controls['jobTermReason']">
        <div *ngIf="cadetForm.controls['jobTermReason'].hasError('required') && cadetForm.controls['jobTermReason'].touched" class="alert alert-danger">Required</div>
      </div>
    </div>
    <!-- ############### Military Service ############################## -->
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">MILITARY SERVICE</p>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['militaryServSelection'].valid && cadetForm.controls['militaryServSelection'].touched}">
        <label for="servedmilitaryservice">Served in the U.S Military:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="servedinmilitary" [(ngModel)]="defaultMilitaryServSelection"
          [formControl]="cadetForm.controls['militaryServSelection']" (change)="servedMilitaryService($event.target.value)"
          style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['militaryServSelection'].hasError('required') && cadetForm.controls['militaryServSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
      <div *ngIf="defaultMilitaryServSelection === 'Yes'" [ngClass]="{'has-error':!cadetForm.controls['militaryBranchServ'].valid && cadetForm.controls['militaryBranchServ'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-5 col-sm-6 col-xs-6 offset-xl-1 offset-lg-1 offset-md-1 usmilitarylabel">
        <label for="branchmilitary">
          <small>
            <i>Please specify the branch:</i>
          </small>
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="200" class="form-control" placeholder="Enter branch" [formControl]="cadetForm.controls['militaryBranchServ']">
        <div *ngIf="cadetForm.controls['militaryBranchServ'].hasError('required') && cadetForm.controls['militaryBranchServ'].touched"
          class="alert alert-danger">Required</div>
      </div>
    </div>
    <div class="form-row" *ngIf="defaultMilitaryServSelection === 'Yes'">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4 militraydatesserved">
        <label for="datesmilitaryservice" class="labelalign">Dates Served:</label>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['militaryDateServFrom'].valid && cadetForm.controls['militaryDateServFrom'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 offset-xl-1 offset-lg-1 offset-md-1">
        <label for="fromdatemilitary" class="labelalign">From:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" onkeydown="return false" type="date" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['militaryDateServFrom']"
            name="militaryfromdate" [(ngModel)]="modelMilFromDate" ngbDatepicker #milfromdate="ngbDatepicker" #militaryFROMdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateMilitary(militaryFROMdate.value, militaryTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="milfromdate.toggle()" type="button">
              <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['militaryDateServFrom'].hasError('required') && cadetForm.controls['militaryDateServFrom'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['militaryBranchServTo'].valid && cadetForm.controls['militaryBranchServTo'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <label for="todatemilitary" class="labelalign">To:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" onkeydown="return false" type="date" class="form-control" placeholder="MM-DD-YYYY" [formControl]="cadetForm.controls['militaryBranchServTo']"
            name="militarytodate"  [minDate]="minDate"  [maxDate]="maxDate" [(ngModel)]="modelMilToDate" ngbDatepicker #miltodate="ngbDatepicker"
            #militaryTOdate (ngModelChange)="checkStartEndDateMilitary(militaryFROMdate.value, militaryTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="miltodate.toggle()" type="button">
              <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['militaryBranchServTo'].hasError('required') && cadetForm.controls['militaryBranchServTo'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
    </div>
    <div class="form-row" *ngIf="defaultMilitaryServSelection === 'Yes'">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4">
        <label for="typeofdischarge">Discharge Type:</label>
      </div>
      <div class="form-group col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-7 offset-xl-1 offset-lg-1 offset-md-1">
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" #active (click)="selectedOtherDiscType(DischTypeRadioOptions = active.value)"
            class="form-check-input" type="radio" name="DischTypeRadioOptions" id="DischTypeActive" value="Active" [formControl]="cadetForm.controls['dischTypeSelectOne']">
          <label class="form-check-label" for="dischargetype3">Active</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" #honor (click)="selectedOtherDiscType(DischTypeRadioOptions = honor.value)"
            class="form-check-input" type="radio" name="DischTypeRadioOptions" id="DischTypeHonor" value="Honorable" [formControl]="cadetForm.controls['dischTypeSelectOne']">
          <label class="form-check-label" for="dischargetype">Honorable</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" #other (click)="selectedOtherDiscType(DischTypeRadioOptions = other.value)"
            class="form-check-input" type="radio" name="DischTypeRadioOptions" id="DischTypeOther" value="Other" [formControl]="cadetForm.controls['dischTypeSelectOne']">
          <label class="form-check-label" for="dischargetype2">Other</label>
        </div>
        <div *ngIf="cadetForm.get('dischTypeSelectOne').invalid" class="optionselectorNot" style="width: 125px;">
          Select one option
        </div>
      </div>
      <div *ngIf="cadetForm.controls['dischTypeSelectOne'].value === 'Other'" [ngClass]="{'has-error':!cadetForm.controls['dischTypeOtherSelected'].valid && cadetForm.controls['dischTypeOtherSelected'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-5 col-sm-6 col-xs-6 offset-xl-4 offset-lg-4 offset-md-4">
        <label for="typeofdischarge">
          <small>
            <i>If
              <strong>Other</strong>, please specify the type:</i>
          </small>
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" maxlength="500" class="form-control" placeholder="Enter type" [formControl]="cadetForm.controls['dischTypeOtherSelected']">
        <div *ngIf="cadetForm.controls['dischTypeOtherSelected'].hasError('required') && cadetForm.controls['dischTypeOtherSelected'].touched"
          class="alert alert-danger">Required</div>
      </div>
    </div>
    <!-- ############## Community/ Volunteer Service ################################# -->
   <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">PREFERRED REQUIREMENTS</p>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['fdnyExpPrgmSelection'].valid && cadetForm.controls['fdnyExpPrgmSelection'].touched}">
        <label for="fdnyexploringdates">FDNY Exploring Program:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="emsfireornot" [(ngModel)]="defaultfdnyExpPrgmSelection"
          [formControl]="cadetForm.controls['fdnyExpPrgmSelection']" (change)="workedAsFDNYExpPrgm($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['fdnyExpPrgmSelection'].hasError('required') && cadetForm.controls['fdnyExpPrgmSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
    </div>
    <!--Date field block-->
    <div class="form-row datefieldalignment" *ngIf="defaultfdnyExpPrgmSelection === 'Yes'">
      <div [ngClass]="{'has-error':!cadetForm.controls['fdnyExpPrgmDateFrom'].valid && cadetForm.controls['fdnyExpPrgmDateFrom'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydateexplabels">
        <label for="fromfdnyexploring">From:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['fdnyExpPrgmDateFrom']"
            name="fdnyexplprgmfromdate" [(ngModel)]="fdnyExpPrgmFromDate" ngbDatepicker #fdnyEPFromdate="ngbDatepicker" #FDNYExpPrgmFROMdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateFDNYExpPrgm(FDNYExpPrgmFROMdate.value, FDNYExpPrgmTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="fdnyEPFromdate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['fdnyExpPrgmDateFrom'].hasError('required') && cadetForm.controls['fdnyExpPrgmDateFrom'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['fdnyExpPrgmDateTo'].valid && cadetForm.controls['fdnyExpPrgmDateTo'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydateexplabels">
        <label for="tofdnyexploring">To:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['fdnyExpPrgmDateTo']"
            name="fdnyexplprgmtodate" [(ngModel)]="fdnyExpPrgmToDate" ngbDatepicker #fdnyEPTodate="ngbDatepicker" #FDNYExpPrgmTOdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateFDNYExpPrgm(FDNYExpPrgmFROMdate.value, FDNYExpPrgmTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="fdnyEPTodate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['fdnyExpPrgmDateTo'].hasError('required') && cadetForm.controls['fdnyExpPrgmDateTo'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
    </div>
    <!--End Date field block-->

    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['fdnyHSSelection'].valid && cadetForm.controls['fdnyHSSelection'].touched}">
        <label for="fdnyexploringdates">FDNY High School:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="emsfireornot" [(ngModel)]="defaultfdnyHSSelection"
          [formControl]="cadetForm.controls['fdnyHSSelection']" (change)="workedAsFDNYHS($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['fdnyHSSelection'].hasError('required') && cadetForm.controls['fdnyHSSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
    </div>
    <!--Date field block-->
    <div class="form-row datefieldalignment" *ngIf="defaultfdnyHSSelection === 'Yes'">
      <div [ngClass]="{'has-error':!cadetForm.controls['fdnyHSDateFrom'].valid && cadetForm.controls['fdnyHSDateFrom'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydateexplabels">
        <label for="fromfdnyexploring">From:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['fdnyHSDateFrom']"
            name="fdnyexplprgmfromdate" [(ngModel)]="fdnyHSFromDate" ngbDatepicker #fdnyEPFromdate="ngbDatepicker" #FDNYHSFROMdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateFDNYHS(FDNYHSFROMdate.value, FDNYHSTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="fdnyEPFromdate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['fdnyHSDateFrom'].hasError('required') && cadetForm.controls['fdnyHSDateFrom'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['fdnyHSDateTo'].valid && cadetForm.controls['fdnyHSDateTo'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydateexplabels">
        <label for="tofdnyexploring">To:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['fdnyHSDateTo']"
            name="fdnyexplprgmtodate" [(ngModel)]="fdnyHSToDate" ngbDatepicker #fdnyEPTodate="ngbDatepicker" #FDNYHSTOdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateFDNYHS(FDNYHSFROMdate.value, FDNYHSTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="fdnyEPTodate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['fdnyHSDateTo'].hasError('required') && cadetForm.controls['fdnyHSDateTo'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['fdnyYEASelection'].valid && cadetForm.controls['fdnyYEASelection'].touched}">
        <label for="fdnyexploringdates">YEMSA (Youth EMS Academy):</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="emsfireornot" [(ngModel)]="defaultfdnyYEASelection"
          [formControl]="cadetForm.controls['fdnyYEASelection']" (change)="workedAsFDNYYEA($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['fdnyYEASelection'].hasError('required') && cadetForm.controls['fdnyYEASelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
    </div>
    <!--Date field block-->
    <div class="form-row datefieldalignment" *ngIf="defaultfdnyYEASelection === 'Yes'">
      <div [ngClass]="{'has-error':!cadetForm.controls['fdnyYEADateFrom'].valid && cadetForm.controls['fdnyYEADateFrom'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydateexplabels">
        <label for="fromfdnyexploring">From:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['fdnyYEADateFrom']"
            name="fdnyexplprgmfromdate" [(ngModel)]="fdnyYEAFromDate" ngbDatepicker #fdnyEPFromdate="ngbDatepicker" #FDNYYEAFROMdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateFDNYYEA(FDNYYEAFROMdate.value, FDNYYEATOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="fdnyEPFromdate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['fdnyYEADateFrom'].hasError('required') && cadetForm.controls['fdnyYEADateFrom'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['fdnyYEADateTo'].valid && cadetForm.controls['fdnyYEADateTo'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydateexplabels">
        <label for="tofdnyexploring">To:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['fdnyYEADateTo']"
            name="fdnyexplprgmtodate" [(ngModel)]="fdnyYEAToDate" ngbDatepicker #fdnyEPTodate="ngbDatepicker" #FDNYYEATOdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateFDNYYEA(FDNYYEAFROMdate.value, FDNYYEATOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="fdnyEPTodate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['fdnyYEADateTo'].hasError('required') && cadetForm.controls['fdnyYEADateTo'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
    </div>

    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">COMMUNITY/VOLUNTEER SERVICE</p>
      </div>
    </div>

 

    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['volEmsFireSelection'].valid && cadetForm.controls['volEmsFireSelection'].touched}">
        <label for="emsfiredates">Volunteer EMS/Firefighter:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="emsfireornot" [(ngModel)]="defaultvolEmsFireSelection"
          [formControl]="cadetForm.controls['volEmsFireSelection']" (change)="workedAsVolEMSFire($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['volEmsFireSelection'].hasError('required') && cadetForm.controls['volEmsFireSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
    </div>
    <div class="form-row datefieldalignment" *ngIf="defaultvolEmsFireSelection === 'Yes'">
      <div [ngClass]="{'has-error':!cadetForm.controls['volEmsFireDateFrom'].valid && cadetForm.controls['volEmsFireDateFrom'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydatelabels">
        <label for="fromemsfire">From:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['volEmsFireDateFrom']"
            name="volemsfirefromdate" [(ngModel)]="volEmsFireFromDate" ngbDatepicker #volEFFromdate="ngbDatepicker" #volEMSFIREFROMdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDatevolEMSFire(volEMSFIREFROMdate.value, volEMSFIRETOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="volEFFromdate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['volEmsFireDateFrom'].hasError('required') && cadetForm.controls['volEmsFireDateFrom'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['volEmsFireDateTo'].valid && cadetForm.controls['volEmsFireDateTo'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 communitydatelabels">
        <label for="toemsfire">To:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['volEmsFireDateTo']"
            name="volemsfiretodate" [(ngModel)]="volEmsFireToDate" ngbDatepicker #volEFTodate="ngbDatepicker" #volEMSFIRETOdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDatevolEMSFire(volEMSFIREFROMdate.value, volEMSFIRETOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="volEFTodate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['volEmsFireDateTo'].hasError('required') && cadetForm.controls['volEmsFireDateTo'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['auxPoliceSelection'].valid && cadetForm.controls['auxPoliceSelection'].touched}">
        <label for="auxpolice">Auxiliary Police:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="auxpoliceornot" [(ngModel)]="defaultauxPoliceSelection"
          [formControl]="cadetForm.controls['auxPoliceSelection']" (change)="workedAsAuxPolice($event.target.value)" style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['auxPoliceSelection'].hasError('required') && cadetForm.controls['auxPoliceSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
    </div>
    <div class="form-row datefieldalignment" *ngIf="defaultauxPoliceSelection === 'Yes'">
      <div [ngClass]="{'has-error':!cadetForm.controls['auxPoliceDateFrom'].valid && cadetForm.controls['auxPoliceDateFrom'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <label for="fromauxppolice">From:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['auxPoliceDateFrom']"
            name="auxpolicefromdate" [(ngModel)]="auxPoliceFromDate" ngbDatepicker #auxpolfromdate="ngbDatepicker" #auxPoliceFROMdate
            [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="checkStartEndDateAuxPolice(auxPoliceFROMdate.value, auxPoliceTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="auxpolfromdate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['auxPoliceDateFrom'].hasError('required') && cadetForm.controls['auxPoliceDateFrom'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['auxPoliceDateTo'].valid && cadetForm.controls['auxPoliceDateTo'].touched}"
        class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <label for="toauxppolice">To:</label>
        <div class="input-group">
          <input [attr.disabled]="UsCitizenNo ? '' : null" type="date" onkeydown="return false" class="form-control" placeholder="YYYY-MM-DD" [formControl]="cadetForm.controls['auxPoliceDateTo']"
            name="auxpolicetodate" [(ngModel)]="auxPoliceToDate" ngbDatepicker #auxpoltodate="ngbDatepicker" #auxPoliceTOdate 
            [minDate]="minDate" [maxDate]="maxDate"  (ngModelChange)="checkStartEndDateAuxPolice(auxPoliceFROMdate.value, auxPoliceTOdate.value)" readonly>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="auxpoltodate.toggle()" type="button">
                <img src="assets/img/calendar-interface-symbol-tool.png" style="width: 1.2rem; height: 1rem; cursor: pointer;" />
            </button>
          </div>
        </div>
        <div *ngIf="cadetForm.controls['auxPoliceDateTo'].hasError('required') && cadetForm.controls['auxPoliceDateTo'].touched"
          class="alert alert-danger labelalign">No past dates over 20 years or future dates</div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4" [ngClass]=" {'has-error':!cadetForm.controls['comntyVolSelection'].valid && cadetForm.controls['comntyVolSelection'].touched}">
        <label for="commvolunteerinfo">Community/Volunteer Work:</label>
        <select [attr.disabled]="UsCitizenNo ? '' : null" class="custom-select" id="commvolunteerornot" [(ngModel)]="defaultcomntyVolSelection"
          [formControl]="cadetForm.controls['comntyVolSelection']" (change)="workedAsCommntyVolunteer($event.target.value)"
          style="width: 75%;display: block;">
          <option [ngValue]="undefined" selected>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <div *ngIf="cadetForm.controls['comntyVolSelection'].hasError('required') && cadetForm.controls['comntyVolSelection'].touched"
          class="alert alert-danger" style="width: 75%;">Select either yes or no</div>
      </div>
      <div [ngClass]="{'has-error':!cadetForm.controls['comntyVolWorkDesc'].valid && cadetForm.controls['comntyVolWorkDesc'].touched}"
        *ngIf="defaultcomntyVolSelection === 'Yes'" class="form-group col-xl-7 col-lg-7 col-md-7 col-sm-8 offset-xl-1 offset-lg-1 offset-md-1 communitylabel">
        <label for="commservicereason">
          <small>
            <i>Please briefly describe below:(75 character limit)</i>
          </small>
        </label>
        <input [attr.disabled]="UsCitizenNo ? '' : null" type="text" class="form-control" maxlength="75" placeholder="" [formControl]="cadetForm.controls['comntyVolWorkDesc']">
        <div *ngIf="cadetForm.controls['comntyVolWorkDesc'].hasError('required') && cadetForm.controls['comntyVolWorkDesc'].touched"
          class="alert alert-danger">Required</div>
      </div>
      <div *ngIf="defaultcomntyVolSelection === 'Yes'" class="form-group col-xl-7 col-lg-7 col-md-7 col-sm-7 offset-xl-4 offset-lg-4 offset-md-4 offset-sm-3 communityexamplelabel">
        <label for="comvolunteercontent">
          <small>
            <i>(<b>Examples may include</b>
              <span>: Youth Groups, Church Activity Involvement, Community Participation, etc.)</span>
            </i>
          </small>
        </label>
      </div>
    </div>

    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">SPECIAL ACCOMMODATION</p>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <label for="uscitizenornot">Are you requesting a special accommodation?</label>
      </div>
    </div>
    <div class="form-row">
     
      <div class="form-group col-xl-9 col-lg-9 col-md-9 col-sm-9">
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" #SaYes (click)="SAOptionYes()" class="form-check-input" type="radio" name="SaOptions" id="UsCitizenYes"
            value="Yes" [formControl]="cadetForm.controls['saChooseOne']">
          <label class="form-check-label" for="labelUsCitizenYes">Yes</label>
        </div>
        <div class="form-check form-check-inline radiostyling">
          <input [attr.disabled]="UsCitizenNo ? '' : null" #SaNo (click)="SAOptionNo()" class="form-check-input" type="radio" name="SaOptions" id="UsCitizenNo"
            value="No" [formControl]="cadetForm.controls['saChooseOne']">
          <label class="form-check-label" for="labelUsCitizenNo">No</label>
        </div>
        <div *ngIf="cadetForm.get('saChooseOne').invalid" class="optionselectorNot" style="width: 125px;">
          Select one option
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="" style="margin-top:20px;margin-left:auto; margin-right:auto;">
        <button type="submit" class="btn btn-primary" [attr.disabled]="UsCitizenNo ? '' : null">Preview Application Form</button>
      </div>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/cadetapplicationform/cadetapplicationform.component.html